import { environment } from '@env/environment';

export function convertToFullPath(path: string) {
  const isFullPath = path.includes('https:') || path.includes('http:');
  const origin = window.location.origin;
  const baseUrl = environment.spa.baseUrl;
  return isFullPath ? path : `${origin}${baseUrl}/${path}`;
}

export function linkToPagePostGet(
  path: string,
  params?: { [key: string]: any },
  target?: '_self' | '_blank',
  method?: 'post' | 'get'
) {
  const form = document.createElement('form');
  form.method = method ?? 'post';
  form.action = convertToFullPath(path);
  form.target = target ?? '_self';

  for (const key in params) {
    if (key in params) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];
      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}
